import React from 'react';

interface AppErrorBoundaryState {
  hasError: boolean;
}

class AppErrorBoundary extends React.Component<React.PropsWithChildren, AppErrorBoundaryState> {
  state: AppErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): AppErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.error('Uncaught error in React tree', error, info);
    }
  }

  handleRefresh = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-vh-100 d-flex justify-content-center align-items-center bg-light p-3">
          <div className="text-center p-4 rounded shadow-sm bg-white" style={{ maxWidth: '420px' }}>
            <div className="mb-3 text-warning">
              <i className="bi bi-exclamation-triangle-fill" style={{ fontSize: '3rem' }} aria-hidden />
            </div>
            <h1 className="h4 mb-2">Something went wrong</h1>
            <p className="text-muted mb-4">
              An unexpected error occurred. Please try refreshing the page. If the problem continues, contact the site administrators.
            </p>
            <button
              type="button"
              className="btn btn-primary"
              onClick={this.handleRefresh}
            >
              <i className="bi bi-arrow-clockwise me-2" />
              Refresh page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default AppErrorBoundary;

